import "core-js/modules/es6.object.keys";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";

/**
 * Created by commyfeng on 2016/10/26.
 */
import Onview from '@tencent/vft-onview';
import BossReport from "./BossReport";

function handleMiddlewares(middlewares, args) {
  if (Array.isArray(middlewares)) {
    middlewares.forEach(function (middleware) {
      middleware['bind'].apply(null, args);
      middleware['update'].apply(null, args);
    });
  }
}
/**
 * vft上报sdk，在原来reportPlugin基础上改造而来
 * 请配合上报表格使用 https://docs.google.com/spreadsheets/d/1IwiNI_F2-Y_JacSml81k0lSCbAdhFKyYTwr0vERwJXA/edit#gid=880181425
 * 详细内容请看 README
 */


var REPORT_KEY = 'vft-report-key';

var _genKey = function () {
  var index = 0;
  return function () {
    return 'key' + index++;
  };
}(); // 是否延迟上报


var _delay = false;
var delayReportList = [];

function readyToReport() {
  _delay = false;
  delayReportList.forEach(function (reportArgs) {
    report.apply(null, reportArgs);
  });
} // 支持多个上报器


var _reporterArr = [];

function report(type, reportContextParam, bindValue) {
  // 如果是延迟上报，则先保存到延迟列表中
  if (_delay) {
    delayReportList.push(Array.from(arguments));
    return;
  }

  reportContextParam = reportContextParam ? Object.assign({}, reportContextParam) : {};
  bindValue = Object.assign(reportContextParam, bindValue);

  _reporterArr.forEach(function (reporter) {
    reporter[type](bindValue);
  });
}

function checkBindValue(bindValue) {
  if (typeof bindValue === 'string') {
    bindValue = {
      f_resource: bindValue
    };
  }

  if (typeof bindValue === 'function') {
    console.error('上报值为函数，可能需要传入业务参数，请先调用');
    return false;
  }

  if (typeof bindValue === 'undefined') {
    console.error('上报内容为undefined：', bindValue);
    return false;
  }

  if (_typeof(bindValue) !== 'object') {
    console.error('上报内容不规范：', bindValue);
    return false;
  } // 特殊逻辑：用于模块上报时，提取字段内容


  if (bindValue._module) {
    Object.assign(bindValue, {
      f_resource: bindValue._module,
      f_module: bindValue._module
    });
  }

  if (bindValue.__reportModule) {
    bindValue = {
      f_resource: bindValue.__reportModule,
      f_module: bindValue.__reportModule,
      __reportModule: bindValue.__reportModule
    };
  }

  for (var key in bindValue) {
    var value = bindValue[key];

    if (typeof value === 'string' && value.indexOf('undefined') >= 0) {
      console.error('上报内容中含有undefined，可能是业务参数没有传入，请检查:', bindValue);
      return false;
    }
  }

  return bindValue;
} // 常规页面boss


var baseBossReport = new BossReport({
  pvBoss: {
    bossId: 6183,
    pwd: 1714812455
  },
  eventBoss: {
    bossId: 6183,
    pwd: 1714812455
  }
}); // 活动boss

var activityBossReport = new BossReport({
  pvBoss: {
    bossId: 5380,
    pwd: 895678138
  },
  eventBoss: {
    bossId: 5380,
    pwd: 895678138
  }
});
var PageState = {
  Init: 'Init',
  Hide: 'Hide',
  Show: 'Show'
};

function getReportContextParams(context) {
  // 通过Vue组件reportModule参数定义组件和子组件的f_module
  if (context.reportParams) {
    return context.reportParams;
  } else if (context.$options['reportParams']) {
    return context.$options['reportParams'];
  } else if (context.$options['reportModule']) {
    return {
      f_module: context.$options['reportModule']
    };
  } else if (context.$parent) {
    return getReportContextParams(context.$parent);
  } else {
    return undefined;
  }
}

var reportPlugin = {
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      reporterArr: [activityBossReport]
    },
        _ref$needReportData = _ref.needReportData,
        needReportData = _ref$needReportData === void 0 ? true : _ref$needReportData,
        _ref$inPrerender = _ref.inPrerender,
        inPrerender = _ref$inPrerender === void 0 ? false : _ref$inPrerender,
        reportData = _ref.reportData,
        reporterArr = _ref.reporterArr,
        _ref$useVftRouter = _ref.useVftRouter,
        useVftRouter = _ref$useVftRouter === void 0 ? false : _ref$useVftRouter,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? false : _ref$delay,
        _ref$middlewares = _ref.middlewares,
        middlewares = _ref$middlewares === void 0 ? [] : _ref$middlewares;

    _reporterArr = reporterArr;
    var unBindExpose = {};
    var unBindClick = {}; // 全局的reportData配置注入

    if (_typeof(reportData) === 'object') {
      for (var moduleName in reportData) {
        reportData[moduleName].__reportModule = moduleName;
      }

      Vue.prototype.reportData = reportData;
    }

    if (delay) {
      _delay = true;
    } // 通过Vue组件reportData参数定义组件的reportData


    if (needReportData) {
      Vue.mixin({
        created: function created() {
          var _this = this;

          if (_typeof(this.$options['reportData']) === 'object') {
            this.reportData = this.$options['reportData']; // 支持在没有f_hottag属性情况下，key作为f_hottag

            var _loop = function _loop(key) {
              if (_typeof(_this.reportData[key]) === 'object') {
                if (!_this.reportData[key].f_hottag) {
                  _this.reportData[key].f_hottag = key;
                }
              } else if (typeof _this.reportData[key] === 'function') {
                var func = _this.reportData[key];

                _this.reportData[key] = function () {
                  var data = func.apply(this, arguments);

                  if (!data.f_hottag) {
                    data.f_hottag = key;
                  }

                  return data;
                }.bind(_this);
              }
            };

            for (var key in this.reportData) {
              _loop(key);
            }
          }
        }
      });
    }

    Vue.directive('report', {
      bind: function bind(el, binding, vnode) {
        if (inPrerender) {
          return;
        }

        var reportContextParam = getReportContextParams(vnode.context);
        var isReportAll = !binding.modifiers.click && !binding.modifiers.expose && !binding.modifiers.pv && !binding.modifiers.module;

        var reportKey = _genKey();

        $(el).attr(REPORT_KEY, reportKey);
        if (!binding.value) return;
        handleMiddlewares(middlewares, [el, binding, vnode]);
        var bindValue = checkBindValue(binding.value);

        if (binding.modifiers.pv) {
          if (useVftRouter) {
            vnode.context.$on('on' + PageState.Show, function () {
              report('pv', reportContextParam, bindValue);
            });
          } else {
            report('pv', reportContextParam, bindValue);
          }
        }

        if (binding.modifiers.module) {
          if (_typeof(bindValue) === 'object' && Object.keys(bindValue).length > 0 && !bindValue._module && !bindValue.__reportModule) {
            console.error('不是模块元素');
            return;
          }
        }

        if (isReportAll || binding.modifiers.click) {
          var clickFunc = function clickFunc() {
            report('click', reportContextParam, bindValue);
          };

          el.addEventListener('click', clickFunc, true);

          unBindClick[reportKey] = function () {
            el.removeEventListener('click', clickFunc, true);
          };
        }

        if (isReportAll || binding.modifiers.expose || binding.modifiers.module) {
          var type = binding.modifiers.module ? 'module' : 'expose';

          if (useVftRouter) {
            if (vnode.context.$pageState === PageState.Show) {
              Vue.nextTick(function () {
                unBindExpose[reportKey] = Onview(el, {
                  once: !binding.modifiers.multi
                }, function () {
                  report(type, reportContextParam, bindValue);
                });
              });
            }

            vnode.context.$on('on' + PageState.Show, function () {
              unBindExpose[reportKey] = Onview(el, {
                once: !binding.modifiers.multi
              }, function () {
                report(type, reportContextParam, bindValue);
              });
            });
            vnode.context.$on('on' + PageState.Hide, function () {
              unBindExpose[reportKey] && unBindExpose[reportKey]();
            });
          } else {
            Vue.nextTick(function () {
              unBindExpose[reportKey] = Onview(el, {
                once: !binding.modifiers.multi
              }, function () {
                report(type, reportContextParam, bindValue);
              });
            });
          }
        }
      },
      update: function update(el, binding) {},
      unbind: function unbind(el) {
        if (inPrerender) {
          return;
        }

        var reportKey = $(el).attr(REPORT_KEY);
        unBindClick[reportKey] && unBindClick[reportKey]();
        delete unBindClick[reportKey];
        unBindExpose[reportKey] && unBindExpose[reportKey]();
        delete unBindExpose[reportKey];
      }
    });

    Vue.prototype.$reportPv = function (bindValue) {
      bindValue = checkBindValue(bindValue);
      if (!bindValue) return;
      report('pv', getReportContextParams(this), bindValue);
    };

    Vue.prototype.$reportModule = function (bindValue) {
      bindValue = checkBindValue(bindValue);
      if (!bindValue) return;
      report('module', getReportContextParams(this), bindValue);
    };

    Vue.prototype.$reportClick = function (bindValue) {
      bindValue = checkBindValue(bindValue);
      if (!bindValue) return;
      report('click', getReportContextParams(this), bindValue);
    };

    Vue.prototype.$reportExpose = function (bindValue) {
      bindValue = checkBindValue(bindValue);
      if (!bindValue) return;
      report('expose', getReportContextParams(this), bindValue);
    };

    Vue.prototype.$reportReady = readyToReport;
    Vue.prototype.report = {
      expose: function expose(bindValue) {
        bindValue = checkBindValue(bindValue);
        if (!bindValue) return;
        report('expose', undefined, bindValue);
      },
      click: function click(bindValue) {
        bindValue = checkBindValue(bindValue);
        if (!bindValue) return;
        report('click', undefined, bindValue);
      },
      ready: readyToReport
    };
  }
};
reportPlugin.BossReport = BossReport;
export default reportPlugin;